<template>
  <q-dialog
    :value="open"
    persistent
    content-class="confirm-dialog"
  >
    <q-card
      style="min-width: 350px; max-width: 625px"
      class="q-pa-lg full-width confirm-dialog__card"
    >
      <q-form class="q-mb-none">
        <q-card-section>
          <div class="confirm-dialog__title">
            {{ title }}
          </div>
        </q-card-section>

        <q-card-section>
          <slot />
        </q-card-section>

        <q-card-actions
          align="right"
          class="text-primary q-px-md q-pb-md"
        >
          <q-btn
            v-if="cancelButton"
            flat
            :label="cancelButton"
            @click="answer('cancel')"
          />
          <q-btn
            color="primary"
            unelevated
            :label="confirmButton"
            @click="answer('confirm')"
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
/**
 * Диалог подтверждения действия
 * @module Shared/Component/ConfirmDialog
 * @fires module:Shared/Component/ConfirmDialog#answer
 * @fires module:Shared/Component/ConfirmDialog#cancel
 * @fires module:Shared/Component/ConfirmDialog#confirm
 * @vue-prop {Boolean} open=false - диалог подтверждения открыт
 * @vue-prop {Boolean} [title] - заголовок диалога
 * @vue-prop {Boolean} [cancelButton] - показать кнопку отмены
 * @vue-prop {String} [confirmButton] - Текст кнопки подтверждения
 * @vue-event {void} confirm - Зпрос подтвержден
 * @vue-event {void} cancel - Зпрос отклонен
 * @vue-event {('cancel' | 'confirm')} answer - Оповещение о резултате ответа
 * */

export default {
  props: {
    /**
     * Диалог подтверждения открыт
     * @type {Boolean}
     * */
    open: {
      type: Boolean,
      required: true,
      default: false
    },
    /**
     * Заголовок диалога
     * @type {Boolean}
     * */
    title: {
      type: String,
      default: 'ВЫ УВЕРЕНЫ?'
    },
    /**
     * Показать кнопку отмены
     * @type {String | Boolean}
     * */
    cancelButton: {
      type: [String, Boolean],
      default: 'НЕТ',
      validator(val) {
        if (typeof val === 'string') {
          return !!val
        }
        if (typeof val === 'boolean') {
          return !val
        }
        return false
      }
    },
    /**
     * Текст кнопки подтверждения
     * @type {String}
     * */
    confirmButton: {
      type: [String],
      default: 'ДА'
    }
  },
  methods: {
    /**
     * Оповещение о резултате ответа
     * @param {('cancel' | 'confirm')} val
     * @fires module:Shared/Component/ConfirmDialog#answer
     * @fires module:Shared/Component/ConfirmDialog#cancel
     * @fires module:Shared/Component/ConfirmDialog#confirm
     * */
    answer(val) {
      /**
       * Оповещение о резултате ответа
       * @event module:Shared/Component/ConfirmDialog#answer
       * @type {('cancel' | 'confirm')}
       * */
      this.$emit('answer', val)

      /**
       * Зпрос отклонен
       * @event module:Shared/Component/ConfirmDialog#cancel
       * @type {void}
       * */

      /**
       * Зпрос подтвержден
       * @event module:Shared/Component/ConfirmDialog#confirm
       * @type {void}
       * */
      this.$emit(val)
    }
  }
}
</script>

<style lang="scss">
.confirm-dialog {
  button {
    width: 129px;
    height: 36px;
    border-radius: 4px;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1.25px;
    text-align: center;
  }

  .confirm-dialog__title {
    font-family: Roboto, sans-serif;
    font-weight: 500;
    color: $color-blue-3;
  }

  .confirm-dialog__card {
    border-radius: 18px;
  }
}

.confirm-dialog {
  font-family: Roboto, sans-serif;
  font-size: 20px;
  line-height: 1.2;

  @media screen and (max-width: $breakpoint-lg-max) {
    font-size: 20px;
  }

  @media screen and (max-width: $breakpoint-md-max) {
    font-size: 20px;
  }

  @media screen and (max-width: $breakpoint-xs-max) {
    font-size: 16px;
  }
}
</style>
